<template>
  <v-treeview
    v-model="selectedItems"
    selectable
    :items="series"
    activatable
    @input="onSelected"
  />
</template>
<script>

export default {
  props: {
    series: {
      type: [Array, Object],
      default: () => ([]),
    },
    selected: {
      type: [Array, Object],
      default: () => ([]),
    },
  },
  data() {
    return {
      selectedItems: this.selected,
    };
  },
  methods: {
    onSelected(item) {
      this.$emit('filtered-items', item);
    },
  },
};
</script>
